import { render, staticRenderFns } from "./invitation.vue?vue&type=template&id=5d7c3077&scoped=true&"
import script from "./invitation.vue?vue&type=script&lang=js&"
export * from "./invitation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d7c3077",
  null
  
)

export default component.exports